/**
 * TREATX-LEGAL-PLATFORM-V1_6 — Thin wrapper for backward compatibility.
 * The concrete implementation lives in `LegalConsentGate.jsx`. This
 * component simply pre-configures the shared gate for the
 * `subscription_purchase` journey so existing call-sites (UpgradeModal)
 * keep working while inheriting the new delta-rendering, bundle
 * grouping, progress indicator and mobile-first refresh introduced in
 * V1_6. No consent logic here.
 */
import React from 'react';
import LegalConsentGate from './LegalConsentGate';

const SubscriptionLegalGate = ({ open, countryContext, onAccept, onCancel, submitting = false }) => (
  <LegalConsentGate
    open={open}
    journeyKey="subscription_purchase"
    countryContext={countryContext}
    submitting={submitting}
    onAccept={onAccept}
    onCancel={onCancel}
    testIdPrefix="subscription-legal"
    ctaLabel="Accept & Continue to Payment"
    subtitle="Please review and accept each agreement before continuing to payment."
  />
);

export default SubscriptionLegalGate;
